import { Link } from 'react-router-dom';
import { pageMeta } from '../../constants/pageMeta';
import { COMPANY_NAME, SITE_NAME } from '../../constants/site';
import PolicyPage, { ContactBlock, List, Section } from '../components/PolicyPage';

const META = pageMeta(
  'Service Fees',
  `What ${SITE_NAME} (${COMPANY_NAME}) charges for booking help, and how fees are shown before you pay.`,
  '/service-fees'
);

export default function ServiceFeesPage() {
  return (
    <PolicyPage
      title="Service Fees"
      meta={META}
      intro={`${SITE_NAME} charges a service fee for the time and expertise our advisors put into planning, booking and supporting your trip. This page explains when it applies and how it is shown.`}
    >
      <Section title="1. Our fee is always shown separately">
        <p>
          Your written quote lists three things on separate lines: the travel provider’s price, taxes and provider
          charges, and our service fee. You see the total before you agree, and we do not charge anything without
          your approval. Our fee is never added to or hidden inside the provider’s price.
        </p>
      </Section>

      <Section title="2. When a service fee applies">
        <List
          items={[
            'New bookings arranged by our advisors (flights, hotels, cars, cruises, packages and group travel).',
            'Changes to an existing booking made at your request.',
            'Cancellations and refund requests handled for you, where the provider rules allow them.',
          ]}
        />
        <p>The amount depends on the type and complexity of the booking and is confirmed in your quote.</p>
      </Section>

      <Section title="3. When there is no fee">
        <List
          items={[
            'Asking questions or requesting a quote — always free and with no obligation.',
            'Cancelling within the U.S. 24-hour window described in our Cancellation & Refund Policy.',
            'Help with a schedule change or cancellation made by the travel provider.',
          ]}
        />
      </Section>

      <Section title="4. Provider charges are separate">
        <p>
          Airlines, hotels, rental companies and cruise lines may charge their own fees — for example baggage, seat
          selection, resort fees, deposits or change penalties. These belong to the provider, follow its rules and
          are not part of our service fee. We point out the ones we know about before you book.
        </p>
      </Section>

      <Section title="5. Refunds of our fee">
        <p>
          Our service fee is generally non-refundable once your booking is issued, because the work has been done.
          The exceptions are set out in our <Link to="/cancellation-refund-policy">Cancellation &amp; Refund Policy</Link>.
        </p>
      </Section>

      <Section title="6. Booking directly">
        <p>
          You never have to use our service. You can book directly with any airline, hotel, car rental company or
          cruise line, usually without a service fee.
        </p>
      </Section>

      <Section title="7. Questions">
        <ContactBlock />
      </Section>
    </PolicyPage>
  );
}
